import { __read } from "tslib";
import { useMemo, useState } from 'react';
/**
 * This utility function is helpful when you need to work with a state derived from a prop that can be initially undefined.
 * For example:
 * function Component(prop) {
 *  const [propState, setPropState] = useMemoizedState(prop);
 * }
 * Caveat with using this hook is that prop can still change and once propState is set to a value that's not undefined, you will
 * need to explicitly call setPropState to update it.
 * @param newState New state
 */
export function useMemoizedState(newState) {
    var _a = __read(useState(), 2), state = _a[0], setState = _a[1];
    var memoizedState = useMemo(function () { return state !== null && state !== void 0 ? state : newState; }, [state, newState]);
    return [memoizedState, setState];
}
//# sourceMappingURL=useMemoizedState.js.map